import React from 'react'
import Logos from '../../img/images/logos.png'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (

        <footer class=" features page-footer text-center text-md-left unique-color-dark pt-0 mt-0">
            <div class="container-fluid" style={{ backgroundColor: " #f4f4fa" }}>
                <div class="container py-1">

                    <div class="flex-center">
                        <div class="row logos-panel mb-2 wow fadeIn" data-wow-delay="0.4s">

                            <div class="col-sm-6 col-md-3 flex-center">
                                <img src="https://mdbootstrap.com/img/Photos/Template/38.png" class="img-fluid" />
                            </div>
                            <div class="col-sm-6 col-md-3 flex-center">
                                <img src="https://mdbootstrap.com/img/Photos/Template/39.png" class="img-fluid" />
                            </div>
                            <div class="col-sm-6 col-md-3 flex-center">
                                <img src="https://mdbootstrap.com/img/Photos/Template/40.png" class="img-fluid" />
                            </div>
                            <div class="col-sm-6 col-md-3 flex-center">
                                <img src="https://mdbootstrap.com/img/Photos/Template/41.png" class="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="top-pink-footer">
                <div class="container">

                    <div class="row py-4 d-flex align-items-center">

                        <div class="col-md-6 col-lg-5 text-center text-md-left mb-md-0">
                            <h6 class="mb-4 mb-md-0 white-text">Get connected with us on social networks!</h6>
                        </div>
                        <div class="col-md-6 col-lg-7 text-center text-md-right">

                            <a href="https://www.facebook.com/iftixor.turamuradov" target="_blank" class="p-2 m-2 fa-lg fb-ic ml-0">
                                <i class="fab fa-facebook-f white-text mr-lg-4"> </i>
                            </a>
                            <a href="https://wwww.twitter.com/iftixor-turamuradov" target="_blank" class="p-2 m-2 fa-lg tw-ic">
                                <i class="fab fa-twitter white-text mr-lg-4"> </i>
                            </a>
                            <a href="https://github.com/IftixorT" target="_blank" class="p-2 m-2 fa-lg gplus-ic">
                                <i class="fab fa-github white-text mr-lg-4"> </i>
                            </a>
                            <a href="https://wwww.linkedin.com/in/iftixor-turamuradov-3062971b3" target="_blank" class="p-2 m-2 fa-lg li-ic">
                                <i class="fab fa-linkedin-in white-text mr-lg-4"> </i>
                            </a>

                        </div>
                    </div>

                </div>
            </div>

            <div class="container mt-5 mb-4 text-center text-md-left">
                <div class="row mt-3">

                    <div class="col-md-3 col-lg-4 col-xl-3 mb-5">
                        <h6 class="spacing font-weight-bold">
                            <strong>Movie Trailers</strong>
                        </h6>
                        <hr class="pink accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                        <p>Movie Trailers website This is a website that offers you romantic movies of merry comedies, cartoons, horror movies.</p>
                        <img src={Logos} style={{ width: '9rem', padding: 0, margin: 0 }} alt="this is logo" /> <span>.com</span>

                    </div>
                    <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-5">
                        <h6 class="spacing font-weight-bold">
                            <strong>Products</strong>
                        </h6>
                        <hr class="pink accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                        <p>
                            <a href="#!">Horror feeling</a>
                        </p>
                        <p>
                            <a href="#!">Funny Cartoons</a>
                        </p>
                        <p>
                            <a href="#!">Romantic passionate</a>
                        </p>
                        <p>
                            <a href="#!">Cartoons surprise</a>
                        </p>
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-5">
                        <h6 class="spacing font-weight-bold">
                            <strong>Useful links</strong>
                        </h6>
                        <hr class="pink accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                        <p>
                            <a href="#!">Pulses movies</a>
                        </p>
                        <p>
                            <a href="#!">Dangerous movies</a>
                        </p>
                        <p>
                            <a href="#!">Horror movies</a>
                        </p>
                        <p>
                            <a href="#!">Korean movies</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-3">
                        <h6 class="spacing font-weight-bold">
                            <strong>Contact</strong>
                        </h6>
                        <hr class="pink accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: '60px' }} />
                        <p>
                            <i class="fas fa-home mr-3"></i>
                            Jambay, Samarkand, Uzbekistan.</p>
                        <p>
                            <i class="fas fa-envelope mr-3"></i>  iftixort5@gmail.com</p>
                        <p>
                            <i class="fas fa-phone mr-3"></i>  +998 93 667 28 05</p>

                    </div>

                </div>
            </div>
            <div class="footer-copyright text-center py-3">
                <div class="container-fluid">
                    © 2021 Copyright:
                    <Link to="/">MovieTrailers.com</Link>
                </div>
            </div>

        </footer>

    )
}

export default Footer
